import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch } from 'react-router-dom'; 
import { Col, Container, Row } from 'reactstrap';
import { actions } from '../../../context';
import Split from '../../Shared/Split';
import AdminList from '../Shared/AdminList';
import NewButton from '../Shared/NewButton';
import NewPartnerModal from './NewPartnerModal';
import Partner from './Partner';

const Partners = () => {
    const dispatch = useDispatch();
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(false);
    const [adding, setAdding] = useState(false);

    const toggleAdding = useCallback(() => setAdding(!adding), [adding]);

    const refreshPartners = useCallback(() =>
        dispatch(actions.partner.getPartners())
            .then((res) => setPartners(res || []))
            .then(() => setLoading(false)), [dispatch]);

    useEffect(() => {
        dispatch(actions.offerings.fetchBitwerxOfferings());
        setLoading(true);
        refreshPartners();
        // eslint-disable-next-line
    }, []);
    return (
        <>
            <NewPartnerModal isOpen={adding} toggle={toggleAdding} refresh={refreshPartners} />
            <Container>
                <Row>
                    <Col>
                        <Split>
                            <h2>
                                <FontAwesomeIcon icon={faUsers} />
                                &emsp;Partners
                            </h2>
                            <div>
                                <NewButton noSpaces id="addPartner" title="Add a partner" onClick={toggleAdding} />
                            </div>
                        </Split>
                        <AdminList
                            items={partners}
                            loading={loading}
                            link="partners"
                        />
                    </Col>
                    <Col lg="9" md="12" sm="12" xs="12">
                        <Switch>
                            <Route
                                path="/admin/partners/:partnerId"
                                component={Partner}
                            />
                        </Switch>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Partners;
